import { ATTRIBUTE_TYPE } from '@web-platform/shared-universal-constants/src/filterAttributes';
import {
  CHECKED_BAG_KEBAB_CASE,
  CABIN_BAG_KEBAB_CASE,
  CABIN_BAG_CAMEL_CASE,
  CHECKED_BAG_CAMEL_CASE,
  kebabToCamel,
} from '@web-platform/shared-universal-constants/src/queryParamMapper';

import type {
  AttributeType,
  ValidAttributeType,
} from '@web-platform/shared-universal-constants/src/filterAttributes';
import type { FareAttribute } from '@web-platform/shared-universal-types/src/context';

const mapSearchParamToAttributeType = (param: string) =>
  ({
    [CABIN_BAG_KEBAB_CASE]: ATTRIBUTE_TYPE.CABIN_BAGGAGE,
    [CHECKED_BAG_KEBAB_CASE]: ATTRIBUTE_TYPE.CHECKED_BAGGAGE,
  })[param];

const mapAttributeTypeToSearchParam = (attributeType: ValidAttributeType) =>
  ({
    [ATTRIBUTE_TYPE.CABIN_BAGGAGE]: CABIN_BAG_KEBAB_CASE,
    [ATTRIBUTE_TYPE.CHECKED_BAGGAGE]: CHECKED_BAG_KEBAB_CASE,
    [ATTRIBUTE_TYPE.CREDIT_CARDS]: undefined,
  })[attributeType];

const mapCamelCaseSearchParamToAttributeType = (param: string) =>
  ({
    [CABIN_BAG_CAMEL_CASE]: ATTRIBUTE_TYPE.CABIN_BAGGAGE,
    [CHECKED_BAG_CAMEL_CASE]: ATTRIBUTE_TYPE.CHECKED_BAGGAGE,
  })[param];

export const getSelectedFiltersFromFareAttributes = (
  fareAttributes: string[] | undefined,
): AttributeType[] =>
  fareAttributes?.map(mapCamelCaseSearchParamToAttributeType).filter(Boolean) || [];

export const mapFilterStateToSearchParam = (filterState: ValidAttributeType[]) =>
  filterState.length ? filterState.map(mapAttributeTypeToSearchParam).join(',') : null;

// Converts fare attribute tokens from GC (kebab-case) to validated camelCase FareAttribute[]
// Keep all GC→Redux boundaries using this helper to avoid format drift
export const gcFareAttributesToRedux = (gcAttrs: string[]): FareAttribute[] =>
  gcAttrs
    .map((attr) => kebabToCamel(attr))
    .filter(
      (attr): attr is FareAttribute =>
        attr === CABIN_BAG_CAMEL_CASE || attr === CHECKED_BAG_CAMEL_CASE,
    );

export const mapSearchParamToFilterState = (fareAttributesParam: string | null) =>
  fareAttributesParam
    ? Array.from(
        new Set(
          fareAttributesParam
            .split(',')
            .map<ValidAttributeType | undefined>(mapSearchParamToAttributeType)
            .filter(Boolean),
        ),
      )
    : [];
